const isRedirectToLogin = (to, user) => {
    // if (to.name === "system@cutover" || to.name === "system@login" || to.name === "system@resetPassword") {
  if (to.name === "system@login" || to.name === "system@resetPassword") {
  return false;
    }

    return !user;
};

export default isRedirectToLogin;
